import { render, staticRenderFns } from "./ListGrupos.vue?vue&type=template&id=0c1e478a"
import script from "./ListGrupos.vue?vue&type=script&lang=js"
export * from "./ListGrupos.vue?vue&type=script&lang=js"
import style0 from "./ListGrupos.vue?vue&type=style&index=0&id=0c1e478a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports